<div class="overlay" [class.overlay--fit-content]="type() === 'fit-content'">
  <div class="card">
    <div class="dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
    <div class="content">
      <h1 class="title">{{ title() | translate }}</h1>
      <p class="subtitle">{{ subtitle() | translate }}</p>
    </div>
  </div>
</div>
